import { useClient, useDictionary } from "@adamlip/okeoke.client"
import { Card, CardBody, Image } from "@nextui-org/react"
import CouponModalV2 from "components/Modals/CouponModalV2"
import { UserContext } from "contexts/UserContext"
import moment from "moment"
import { useContext, useEffect, useState } from "react"
import toast from "react-hot-toast"
import LoadSvg from "utils/LoadSvg-v3"

export default function Coupons({ element }) {
  const { getValue } = useDictionary()
  const { coupons, activateCoupon, refreshCoupons, isVipBrand } =
    useContext(UserContext)
  const { getName } = useClient()
  const [isOpen, setIsOpen] = useState(false)
  const [selectedCoupon, setSelectedCoupon] = useState(null)
  const [couponList, setCouponList] = useState(null)
  const [activateInProgress, setActivateInProgress] = useState(false)
  const [currentCoupon, setCurrentCoupon] = useState(null)
  const handleActivateCoupon = (coupon) => {
    if (coupon?.active) return null
    setActivateInProgress(coupon?.code)
    activateCoupon(coupon?.code, false).then((response) => {
      if (response?.success) {
        toast.success(getValue("app_v2_coupons_activated"))
        refreshCoupons()
        setCurrentCoupon(response.data)
      }
      setActivateInProgress(false)
    })
  }
  const handleDeActivateCoupon = (coupon) => {
    if (!coupon?.active) return null
    setActivateInProgress(coupon?.code)
    activateCoupon(coupon?.code, true).then((response) => {
      if (response?.success) {
        toast.success(getValue("app_v2_coupons_deactivated"))
        refreshCoupons()
        setCurrentCoupon(response.data)
      }
      setActivateInProgress(false)
    })
  }
  const openCouponModal = (coupon) => {
    if (coupon != null) {
      setIsOpen(true)
      setSelectedCoupon(coupon)
    }
  }
  useEffect(() => {
    let filtered = coupons || []
    let couponsToShow = element?.attributes?.couponsToShow
    if (couponsToShow === "all" || couponsToShow == null) {
      filtered = coupons
    } else if (couponsToShow === "claimed") {
      filtered = coupons?.filter(
        (coupon) => coupon?.isClaimed === true || coupon?.isClaimed === 1
      )
    } else if (couponsToShow === "activated") {
      filtered = coupons?.filter((coupon) => coupon?.active === true)
    } else if (couponsToShow === "notActivated") {
      filtered = coupons?.filter((coupon) => coupon?.active !== true)
    }
    setCouponList(filtered)
  }, [coupons, element])

  if (!isVipBrand) return null

  return (
    <div className="px-3">
      {getName(element?.attributes?.label) && (
        <p className="text-lg font-bold mb-2">
          {getName(element?.attributes?.label)}
        </p>
      )}
      <div className="flex flex-row flex-nowrap gap-2 overflow-y-hidden overflow-x-scroll w-full">
        {(couponList || [])?.length === 0 && (
          <div className="">
            {getValue("app_v2_coupons_myActiveCoupons_no_coupons")}
          </div>
        )}
        {(couponList || []).map((coupon) => {
          return (
            <Card
              isPressable
              onPress={() => openCouponModal(coupon)}
              key={coupon?.id}
              shadow="sm"
              className="flex flex-col bg-[var(--coupon-bg)] text-[var(--coupon-text)] w-[350px] min-w-[350px]"
            >
              <CardBody>
                {coupon?.attributes?.imageUrl != null && (
                  <Image
                    src={coupon?.attributes?.imageUrl}
                    className="mb-2 w-full !max-w-[100%] max-h-[180px] min-w-[100%] min-h-[180px] z-0"
                    classNames={{
                      img: "object-cover",

                      wrapper:
                        "w-full h-[180px] max-h-[180px] !max-w-[100%] overflow-hidden rounded-md bg-[var(--coupon-imageBg)]",
                    }}
                  />
                )}
                <div className="flex flex-col ">
                  <div className="w-full text-lg font-bold text-[var(--coupon-nameText)]">
                    {coupon?.label != null
                      ? getName(coupon?.label)
                      : coupon?.name}
                  </div>
                  <div className="gap-1 flex flex-col">
                    <div className="w-full line-clamp-3 text-sm mt-2 font-light">
                      {getName(coupon?.description) ||
                        getValue("app_v2_coupons_noDescription")}
                    </div>
                    <div className="flex flex-row items-center font-light justify-start gap-1 text-sm">
                      <div className="label">
                        {getValue("app_v2_coupons_couponAvailable")}:
                      </div>
                      <div className="value">
                        {moment(coupon.endDate).format("YYYY.MM.DD")}
                      </div>
                    </div>
                    {coupon?.stores != null && (
                      <>
                        <div className="flex flex-row gap-1 items-center justify-start text-sm">
                          <LoadSvg name="setLocation" />
                          <div className="count">
                            {(coupon?.stores || []).length}
                          </div>
                          <div className="text">
                            {getValue("app_v2_coupons_storesAvailable")}
                          </div>
                        </div>
                      </>
                    )}
                  </div>
                  <p className="text-sm mt-2">
                    {getValue("app_v2_coupons_clickToDetails")}
                  </p>
                </div>
              </CardBody>
            </Card>
          )
        })}
      </div>
      <CouponModalV2
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        coupon={selectedCoupon}
        couponList={couponList}
        setCouponList={setCouponList}
        setCurrentCoupon={setCurrentCoupon}
        currentCoupon={currentCoupon}
        handleActivateCoupon={handleActivateCoupon}
        handleDeActivateCoupon={handleDeActivateCoupon}
        activateInProgress={activateInProgress}
      />
    </div>
  )
}
